import React, { useEffect, useState } from "react";

function BoardOfDirectors() {
  const [docs, setDocs] = useState({});
  const [loading, setLoading] = useState(true);
  const [board, setBoard] = useState([]);

  useEffect(() => {
    fetch("https://wyrowingbackend.onrender.com/board")
      .then((res) => res.json())
      .then((data) => setBoard(data))
      .catch((err) => console.error("Error loading board:", err));
  }, []);

  useEffect(() => {
    fetch("https://wyrowingbackend.onrender.com/docs")
      .then((res) => res.json())
      .then((data) => {
        setDocs(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error loading documents:", err);
        setLoading(false);
      });
  }, []);

  return (
 <div className="centered-page">
      <h2>Friends of Roosevelt High School Rowing</h2>
              <h3>Current Board of Directors</h3>
        <p>
          The Friends of Roosevelt High School Rowing is a non-profit
          organization dedicated to supporting the rowing program at Roosevelt
          High School. We typically meet on the first Wednesday of each month at
          the Wyandotte Boat Club, see calendar for details. Here you'll find
          our current Bylaws, meeting minutes, and other important documents. If
          you have any questions or would like to get involved, please contact
          us at the email below.
        </p>
      <div style={{ marginBottom: "2rem" }}>
        <h3>Current Board of Directors</h3>
        <ul style={{ listStyle: "none", padding: 0 }}>
          {board.map((member, idx) => (
            <li key={idx} style={{ fontSize: "1.1rem", margin: "0.5rem 0" }}>
              <strong>{member.name}</strong>
              {member.position ? ` — ${member.position}` : ""}
              {member.termUp ? ` (Term up: ${member.termUp})` : ""}
            </li>
          ))}
        </ul>

        <div
          style={{
            marginBottom: "1rem",
            fontWeight: "bold",
            fontSize: "1.4rem",  
            padding: "2rem .1rem" , 
            color: "rgb(22, 22, 116)",
          }}
        >
          Contact Us
        </div>
        <a
          href="mailto:friendsofrhsrowing@gmail.com"
          style={{
            display: "inline-block",
            background: "linear-gradient(90deg, #162278 60%, #3a4edc 100%)",
            color: "#fff",
            padding: "1.1rem 2.5rem",
            borderRadius: "12px",
            fontWeight: "bold",
            fontSize: "1.3rem",
            textDecoration: "none",
            boxShadow: "0 4px 16px rgba(22,22,116,0.18)",
            letterSpacing: "1px",
            transition: "background 0.2s, transform 0.2s",
          }}
          onMouseOver={(e) => (e.currentTarget.style.background = "#3a4edc")}
          onMouseOut={(e) =>
            (e.currentTarget.style.background =
              "linear-gradient(90deg, #162278 60%, #3a4edc 100%)")
          }
        >
          friendsofrhsrowing@gmail.com
        </a>
      </div>
      <h2>Board Documents</h2>
      {loading ? (
        <p>Loading documents...</p>
      ) : (
        Object.keys(docs)
          .sort((a, b) => b.localeCompare(a)) // sort descending
          .map((year) => (
            <div key={year} style={{ marginTop: "3rem" }}>
              <h4 style={{ fontWeight: "bold", fontSize: "1.3rem" }}>{year}</h4>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th
                      style={{
                        textAlign: "left",
                        borderBottom: "2px solid #000",
                        padding: "0.5rem",
                      }}
                    >
                      Document Name
                    </th>
                    <th
                      style={{
                        textAlign: "left",
                        borderBottom: "2px solid #000",
                        padding: "0.5rem",
                      }}
                    >
                      Type
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {docs[year].map((doc, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          padding: "0.5rem",
                          borderBottom: "1px solid #ccc",
                        }}
                      >
                        <a
                          href={doc.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "rgb(22, 22, 116)",
                            textDecoration: "none",
                          }}
                        >
                          {doc.name}
                        </a>
                      </td>
                      <td
                        style={{
                          padding: "0.5rem",
                          borderBottom: "1px solid #ccc",
                        }}
                      >
                        {doc.mimeType.split("/").pop()}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))
      )}
    </div>
  );
}

export default BoardOfDirectors;
